"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialDevicesResponseT = exports.SerialDevicesResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const serial_device_js_1 = require("../../solarxr-protocol/rpc/serial-device.js");
class SerialDevicesResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialDevicesResponse(bb, obj) {
        return (obj || new SerialDevicesResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialDevicesResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialDevicesResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    devices(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new serial_device_js_1.SerialDevice()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    devicesLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startSerialDevicesResponse(builder) {
        builder.startObject(1);
    }
    static addDevices(builder, devicesOffset) {
        builder.addFieldOffset(0, devicesOffset, 0);
    }
    static createDevicesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startDevicesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endSerialDevicesResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialDevicesResponse(builder, devicesOffset) {
        SerialDevicesResponse.startSerialDevicesResponse(builder);
        SerialDevicesResponse.addDevices(builder, devicesOffset);
        return SerialDevicesResponse.endSerialDevicesResponse(builder);
    }
    unpack() {
        return new SerialDevicesResponseT(this.bb.createObjList(this.devices.bind(this), this.devicesLength()));
    }
    unpackTo(_o) {
        _o.devices = this.bb.createObjList(this.devices.bind(this), this.devicesLength());
    }
}
exports.SerialDevicesResponse = SerialDevicesResponse;
class SerialDevicesResponseT {
    constructor(devices = []) {
        this.devices = devices;
    }
    pack(builder) {
        const devices = SerialDevicesResponse.createDevicesVector(builder, builder.createObjectOffsetList(this.devices));
        return SerialDevicesResponse.createSerialDevicesResponse(builder, devices);
    }
}
exports.SerialDevicesResponseT = SerialDevicesResponseT;
